export default "__VITE_ASSET__c5c840e0__"